import { useMemo } from 'react';
import { MarketAnalysisData, VolumeVisibility } from '../../types';
import { ChartLayout } from '../types';
import { LAYOUT } from '../constants';

interface UseChartLayoutParams {
    width: number;
    showVolumePanel: boolean;
    volumeVisibility: VolumeVisibility;
    analysisData: MarketAnalysisData | null | undefined;
}

export function useChartLayout({
    width,
    showVolumePanel,
    volumeVisibility,
    analysisData,
}: UseChartLayoutParams): ChartLayout {
    return useMemo(() => {
        const showVolume = Boolean(
            showVolumePanel &&
            volumeVisibility.showVolume &&
            analysisData?.candles &&
            analysisData.candles.length > 0
        );

        const svgTotalHeight = showVolume
            ? LAYOUT.SVG_HEIGHT_WITH_VOLUME
            : LAYOUT.SVG_HEIGHT_WITHOUT_VOLUME;

        const margin = LAYOUT.DEFAULT_MARGIN;
        const totalInnerHeight = svgTotalHeight - margin.top - margin.bottom;
        const innerWidth = width - margin.left - margin.right;

        const priceHeight = showVolume
            ? totalInnerHeight * (1 - LAYOUT.VOLUME_PANEL_RATIO) - LAYOUT.VOLUME_GAP / 2
            : totalInnerHeight;

        const volumeHeight = showVolume
            ? totalInnerHeight * LAYOUT.VOLUME_PANEL_RATIO - LAYOUT.VOLUME_GAP / 2
            : 0;

        const volumeYOffset = priceHeight + LAYOUT.VOLUME_GAP;
        const totalChartHeight = showVolume ? volumeYOffset + volumeHeight : priceHeight;

        return {
            margin,
            innerWidth,
            priceHeight,
            volumeHeight,
            volumeYOffset,
            totalChartHeight,
            svgTotalHeight,
            showVolume,
        };
    }, [width, showVolumePanel, volumeVisibility.showVolume, analysisData?.candles]);
}
